module.exports = __webpack_public_path__ + "static/media/table.27b2d07d.png";